export default "__VITE_ASSET__Ccaqe2$n__"